exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr {\r\n    margin-top: 2px;\r\n    margin-bottom: 2px;\r\n    border: 1px dotted;\r\n}\r\n\r\n.table-borderless > tbody > tr > td,\r\n.table-borderless > tbody > tr > th,\r\n.table-borderless > thead > tr > td,\r\n.table-borderless > thead > tr > th {\r\n    border: none;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/detalle-nota-credito/detalle-nota-credito.component.css
// module id = ../../../../../src/app/components/modals/detalle-nota-credito/detalle-nota-credito.component.css
// module chunks = main